import { axios } from '@Root/API'

export const edit = payload => {
	return axios.put(`training-facility-detail`, payload)
}
